import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";
import { persistor } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CareersHeader from "./header/CareersHeader";
import useClientConfig from "../../config/careers/clientConfig";
import CareersCustomFooter from "./CareersFooter/CareersCustomFooterBase";

const CompletionRoot = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routeParams = useParams();
  const { clientSiteSettings } = useClientConfig();
  const [clientIdFound, setClientIdFound] = useState<boolean>(false);
  const [jobViewDesign, setJobViewDesign] = useState<boolean>(false);
  const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
  const templateName = clientSiteSettings?.templateName;

  useEffect(() => {

    persistor.flush().then(() => {
      return persistor.purge();
    });
    navigate(location.pathname);
  }, []);


  useEffect(() => {
    if (location.pathname === "/" ||
      location.pathname === `/view/${routeParams?.id}` ||
      location.pathname === `/view/${routeParams?.id}/apply-job/from/direct` ||
      location.pathname === `/view/${routeParams?.id}/apply-job/register/from/direct`) {
      setClientIdFound(false);
    } else {
      setClientIdFound(!false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (clientSiteSettings?.jobViewDesign === true && location.pathname === `/view/${routeParams?.id}`) {
      setJobViewDesign(!false);
    } else {
      setJobViewDesign(false);
    }

    if (templateName === "template_34") {
      setJobViewDesign(false);
    }


    if (clientConfig?.data?.data?.clientSettings?.isMicroSite === 1) {
      const pathSegments = location.pathname.split("/");
      const fromIndex = pathSegments.indexOf("from");
      let fromWhere = "";
      if (fromIndex !== -1 && fromIndex + 1 < pathSegments.length) { // If from attribute in the URL is null then it will redirect to direct otherwise it will redirect to the from attribute
        fromWhere = pathSegments[fromIndex + 1];
      } else {
        fromWhere = "direct";
      }
      if (clientConfig?.data?.data?.clientSettings.jobId !== "") {
        navigate(`/view/${clientConfig?.data?.data?.clientSettings.jobId}/apply-job/from/${fromWhere}`);
      }
    }

  }, [location.pathname, clientConfig]);

  //Resolves if the current client has a custom footer using the inbuilt clientids
  const hasCustomFooter = (id: any) => {
    return clientSiteSettings?.showFooter;
  };

  return (
    <>
      {/* {sessionStorage.getItem("Token") ? ( */}
      <>
        <div className="conpletion-header-div">
          <CareersHeader />
        </div>
        <div id="careers-body" className={jobViewDesign ? "careers-bg mob-job-view" : clientIdFound ? "careers-bg-new" : "careers-bg "}>

          <div className={clientSiteSettings?.templateName === "template_4" ?
            (location.pathname === `/view/${routeParams?.id}/apply-job/from/${routeParams?.from}` ||
              location.pathname === `/view/${routeParams?.id}/apply-job/register/from/${routeParams?.from}` ||
              location.pathname === `/verify-email/${routeParams?.token}` ||
              location.pathname === `/unsubscribe/${routeParams?.token}`
            ) ?
              "apply-body" : "client-body" : ""}>
            <Outlet />
          </div>
        </div>
        {hasCustomFooter(clientConfig?.data?.data?.clientSettings?.clientId) ?
          <div className="conpletion-footer-div">
            <CareersCustomFooter clientSiteSettings={clientSiteSettings} />
          </div>
          : ""}
      </>
      {/* ) : (
        ""
      )} */}
    </>
  );
};

export default CompletionRoot;
